import React from 'react'

import classes from './Wrapper.module.scss'

export const Wrapper = ({
  children,
}: React.HTMLAttributes<HTMLElement>): JSX.Element => {
  return <div className={classes.bg}>{children}</div>
}
